export enum RepairCostingLocalStorage {
  KEY = 'repairCostingFilterKey',
  STATUS = 'repairCostingFilterStatus',
}
